import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  HomeIcon,
  AcademicCapIcon,
  UserGroupIcon,
  ClipboardDocumentListIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';

interface MobileNavigationProps {
  className?: string;
}

interface MobileNavItem {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  requiresStaff?: boolean;
}

const mobileNavigation: MobileNavItem[] = [
  {
    name: 'Home',
    href: '/dashboard',
    icon: HomeIcon,
  },
  {
    name: 'Classes',
    href: '/classrooms',
    icon: AcademicCapIcon,
  },
  {
    name: 'Children',
    href: '/children',
    icon: UserGroupIcon,
  },
  {
    name: 'Observe',
    href: '/observations',
    icon: ClipboardDocumentListIcon,
  },
  {
    name: 'Reports',
    href: '/reports',
    icon: ChartBarIcon,
  },
];

const MobileNavigation: React.FC<MobileNavigationProps> = ({ className = '' }) => {
  const { user } = useAuth();
  const location = useLocation();

  // Filter navigation based on user permissions
  const filteredNavigation = mobileNavigation.filter(item => {
    if (item.requiresStaff && !user?.is_staff) {
      return false;
    }
    return true;
  });

  return (
    <nav className={`fixed bottom-0 left-0 right-0 z-30 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] transition-colors duration-200 ${className}`}>
      <div className="flex justify-around">
        {filteredNavigation.map((item) => {
          const isActive = location.pathname === item.href || 
                         (item.href !== '/dashboard' && location.pathname.startsWith(item.href));
          
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={`flex flex-col items-center py-2 px-3 min-w-0 flex-1 ${
                isActive 
                  ? 'text-primary-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100'
              }`}
            >
              <item.icon className={`w-6 h-6 ${isActive ? 'text-primary-600' : 'text-gray-500 dark:text-gray-400'}`} />
              <span className={`text-xs mt-1 truncate ${isActive ? 'font-medium' : 'font-normal'}`}>
                {item.name}
              </span>
              {isActive && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-0.5 bg-primary-600 rounded-full" />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavigation;
